import createAction, { createClearAction } from "../app/createAction";
import {
    ADD_MOBILE_SLIDER_PAGE,
    AUTH_REGISTER_MOBILE_APP_ACTION,
    AUTH_REGISTER_MOBILE_APP_FAILURE,
    AUTH_REGISTER_MOBILE_APP_SUCCESS,
    AUTH_VERIFY_MOBILE_APP_ACTION,
    AUTH_VERIFY_MOBILE_APP_FAILURE,
    AUTH_VERIFY_MOBILE_APP_SUCCESS,
    CLOSE_MOBILE_SLIDER_PAGE,
    OPEN_MOBILE_SLIDER_PAGE,
    REGISTRATION_PREPARE_MOBILE_ACTION,
    REGISTRATION_START_MOBILE_ACTION,
} from "./mobileAppConstants";
import type { IOpenMobileSliderPageAction } from "./types/mobileAppActions.t";

/**
 * @deprecated use openLocationAction
 */
export const openMobileSliderPageAction = (payload: IOpenMobileSliderPageAction) => createAction<typeof OPEN_MOBILE_SLIDER_PAGE, IOpenMobileSliderPageAction>(OPEN_MOBILE_SLIDER_PAGE, payload);
export const closeMobileSliderPageAction = (payload?: unknown) => createClearAction<typeof CLOSE_MOBILE_SLIDER_PAGE>(CLOSE_MOBILE_SLIDER_PAGE, payload);

/**
 * @deprecated use addLocationAction
 */
export const addMobileSliderPageAction = (payload: IOpenMobileSliderPageAction) => createAction<typeof ADD_MOBILE_SLIDER_PAGE, IOpenMobileSliderPageAction>(ADD_MOBILE_SLIDER_PAGE, payload);

export const registrationPrepareMobileAction = (payload?: unknown) => createClearAction<typeof REGISTRATION_PREPARE_MOBILE_ACTION>(REGISTRATION_PREPARE_MOBILE_ACTION, payload);
export const registrationStartMobileAction = (payload?: unknown) => createClearAction<typeof REGISTRATION_START_MOBILE_ACTION>(REGISTRATION_START_MOBILE_ACTION, payload);

export const authRegisterMobileAppAction = (payload?: unknown) => createClearAction<typeof AUTH_REGISTER_MOBILE_APP_ACTION>(AUTH_REGISTER_MOBILE_APP_ACTION, payload);
export const authRegisterMobileAppSuccess = (payload?: unknown) => createClearAction<typeof AUTH_REGISTER_MOBILE_APP_SUCCESS>(AUTH_REGISTER_MOBILE_APP_SUCCESS, payload);
export const authRegisterMobileAppFailure = (payload?: unknown) => createClearAction<typeof AUTH_REGISTER_MOBILE_APP_FAILURE>(AUTH_REGISTER_MOBILE_APP_FAILURE, payload);

export const authVerifyMobileAppAction = (payload?: unknown) => createClearAction<typeof AUTH_VERIFY_MOBILE_APP_ACTION>(AUTH_VERIFY_MOBILE_APP_ACTION, payload);
export const authVerifyMobileAppSuccess = (payload?: unknown) => createClearAction<typeof AUTH_VERIFY_MOBILE_APP_SUCCESS>(AUTH_VERIFY_MOBILE_APP_SUCCESS, payload);
export const authVerifyMobileAppFailure = (payload?: unknown) => createClearAction<typeof AUTH_VERIFY_MOBILE_APP_FAILURE>(AUTH_VERIFY_MOBILE_APP_FAILURE, payload);

